// Abre "A Peça em Si" fora da tela do Caderno (rota /peca/:workspaceId/:pieceId).
//
// 20/09/2026 (pedido do titular): Normal e Redline abriam SEMPRE na mesma
// janela porque o nome do alvo do window.open era só `peca_<id>` — o navegador
// reaproveita a janela de mesmo nome. Agora o nome inclui o modo, então cada
// modo tem a sua própria janela/aba (e cliques repetidos no MESMO modo
// continuam reaproveitando a dele). O modo também vai na URL (?modo=), pra a
// página aberta já nascer no modo certo.
//
// Sem 3º argumento (features) de propósito: com "width=...,height=..." o
// Chrome abre um POPUP, e popup não tem barra de abas — não dá pra agrupar.
// Sem features abre como aba comum, que o titular pode agrupar/arrastar.

export function abrirPecaEmNovaAba(workspaceId, pieceId, modo) {
  const wId = String(workspaceId || '');
  const pId = String(pieceId || '');
  if (!wId || !pId) return;
  const m = modo === 'redline' ? 'redline' : 'normal';
  window.open(`/peca/${wId}/${pId}?modo=${m}`, `peca_${pId}_${m}`);
}
